// src/pages/admin/AdminIndustries.jsx
import React, { useState, useEffect } from 'react';
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import AdminLayout from '../components/admin/AdminLayout';
import { Drawer, DrawerTrigger, DrawerContent } from "../components/ui/drawer";
import { fetchWithAuth } from '../utils/fetchWithAuth';
import { PlusIcon } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import IndustryTable from "../components/admin/IndustryTable";
import IndustryForm from "../components/admin/IndustryForm";

const API = process.env.REACT_APP_API_BASE;

export default function Industries() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editIndustry, setEditIndustry] = useState(null);
    const [industries, setIndustries] = useState([]);

    const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const decoded = jwtDecode(token);
      if (decoded?.usertype !== 'master') {
        navigate('/login');
      }
    } catch (err) {
      console.error('Invalid token', err);
      navigate('/login');
    }
  }, [navigate]);
  
    useEffect(() => {
        fetchWithAuth(`${API}/api/industries`)
          .then(res => res.json())
          .then(data => {
            const items = Array.isArray(data) ? data : data.industries || data.data || [];
            setIndustries(items);
            console.log(items);
          })
          .catch(err => {
            console.error('Failed to fetch industries:', err);
            setIndustries([]); // fallback to empty array
          });
      }, []);
      
  
    const handleAdd = () => {
      setEditIndustry(null);
      setDrawerOpen(true);
    };
  
    const handleEdit = (industry) => {
      setEditIndustry(industry);
      setDrawerOpen(true);
    };
  
    return (
        <AdminLayout>
      <div className="px-4 lg:px-8 py-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-xl font-semibold">Industries</h1>
          <Button onClick={handleAdd}>
            <PlusIcon className="w-4 h-4 mr-2" />
            Add Industry
          </Button>
        </div>
  
        <Card>
          <CardContent className="p-0">
            <IndustryTable
              industries={industries}
              setIndustries={setIndustries}
              onEdit={handleEdit}
            />
          </CardContent>
        </Card>
  
        <Drawer open={drawerOpen} onOpenChange={setDrawerOpen}>
          <DrawerContent>
            <IndustryForm
              editIndustry={editIndustry}
              onClose={() => setDrawerOpen(false)}
              onReload={setIndustries}
            />
          </DrawerContent>
        </Drawer>
      </div>
      </AdminLayout>
    );
  }